import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const registrySheetTelemetryObject = createTelemetryObject({
  actions: {
    registrySheetDismissed: (page: string) => ({
      category: 'registrySheet',
      action: 'ButtonInteracted',
      page,
      label: 'Maybe Later',
    }),
    registrySheetAddGiftClicked: (page: string) => ({
      category: 'registrySheet',
      action: 'ButtonInteracted',
      page,
      label: 'Add More Gifts',
    }),
  },
});

const { useTelemetry: useRegistrySheetTelemetry } = createTelemetry(registrySheetTelemetryObject);

export { useRegistrySheetTelemetry };
